import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { DateInput } from 'ziphy-web-shared/basic/lib/forms/fields';
import MultiSelect from 'ziphy-web-shared/basic/lib/forms/fields/multiSelect/LegacyMultiSelect';
import { ConnectedGroup } from 'ziphy-web-shared/basic/lib/simple';
import { RadioTabs } from 'ziphy-web-shared/basic/lib/tabs';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import styles from './ApptsSearch.module.scss';
const ApptsSearch = ({ filters, className }) => {
    const { t } = useTranslation();
    const { view, practiceId, showFilters, dateFrom, dateTo } = filters;
    const practiceItems = $auth.availablePractices.map((x) => ({ id: x.id, text: x.name }));
    const minDate = moment().add(-1, 'year');
    const maxDate = moment().add(2, 'month');
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsxs("div", Object.assign({ className: classNames(styles.apptsSearch, 'mb-20') }, { children: [_jsx(RadioTabs, { value: view.value, setValue: view.onChange, items: [
                            { id: 'current', text: t('label.current') },
                            { id: 'history', text: t('label.history') },
                        ], className: styles.tabs, mode: "dark" }), practiceItems.length > 1 && (_jsx("div", Object.assign({ className: styles.practiceSelect }, { children: _jsx(MultiSelect, { items: practiceItems, field: practiceId, mode: ['sm'], allOption: t('label.all_practices'), direction: ['bottom'] }) }))), _jsx(Button, Object.assign({ mode: ['custom-filters'], isActive: showFilters.value, leftElement: 'filtersList', onClick: () => showFilters.onChange(!showFilters.value) }, { children: t('btn.filters') }))] })), showFilters.value && (_jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: "col-12 col-lg-5" }, { children: _jsx(ConnectedGroup, { renderItems: [
                            ({ getClass }) => {
                                return (_jsx(DateInput, { label: t('label.date_from'), field: {
                                        value: dateFrom.value,
                                        onChange: dateFrom.onChange,
                                        isInvalid: dateFrom.isInvalid,
                                    }, mode: "sm", minDate: minDate, maxDate: maxDate, readonly: true, clear: true, onClear: () => {
                                        $router.searchParams.remove('dateFrom');
                                        $router.searchParams.remove('view');
                                    }, innerClassName: getClass() }));
                            },
                            ({ getClass }) => {
                                return (_jsx(DateInput, { label: t('label.date_to'), field: {
                                        value: dateTo.value,
                                        onChange: dateTo.onChange,
                                        isInvalid: dateTo.isInvalid,
                                    }, mode: "sm", minDate: minDate, maxDate: maxDate, readonly: true, clear: true, onClear: () => {
                                        $router.searchParams.remove('dateTo');
                                    }, innerClassName: getClass() }));
                            },
                        ] }) })) })))] })));
};
export default observer(ApptsSearch);
